module.exports = __webpack_public_path__ + "img/2.b997e170.png";